import Button from "@/components/button/Button"
import { useModalDarkContext } from "@/components/context/ModalDarkContext"
import { ApplyItemType } from "@/components/modal-dark/modal-dark-platform-content/single-submission/SingleSubmission"
import HexagonGroup from "@/components/modal-dark/modal-dark-platform-content/start-notice/hexagon-group/HexagonGroup"
import WebsiteTypography from "@/components/websiteTypography/WebsiteTypography"
import { Col, Row } from "antd"
import useBreakpoint from "antd/es/grid/hooks/useBreakpoint"
import { FC } from "react"
import "./AutoApprovalInfo.less"
import applyImage03 from "./assets/intersection.svg"
import applyImage01 from "./assets/list.svg"
import applyImage02 from "./assets/mark.svg"

const { Title, Paragraph } = WebsiteTypography

const AutoApprovalInfo: FC = () => {
  const { xxl, xl, lg, md, sm } = useBreakpoint()
  const { setIsModalDarkOpen } = useModalDarkContext()

  const applyItems: ApplyItemType[] = [
    {
      id: "1",
      description: "Applicants create & submit an application directly on your portal as normal",
      imageUrl: applyImage01,
    },
    {
      id: "2",
      description: "The system analyzes and reviews their project information automatically",
      imageUrl: applyImage02,
    },
    {
      id: "3",
      description: "Approvals are automatically generated and the applicant receives instant feedback and results",
      imageUrl: applyImage03,
    },
  ]

  const handleClose = () => {
    setIsModalDarkOpen(false)
  }

  return (
    <Row justify={"center"} className={"auto-approval-info"}>
      <Col span={20} xxl={20} xl={20} lg={20} md={23} sm={23} xs={23}>
        <Title level={!(xxl || xl || lg) ? 4 : 3} centered color={"white"} style={{ marginTop: 0, paddingBottom: 24 }}>
          <span className={"w300"}>{"How Auto-Approvals "}</span>
          <span className={"bold"}>{"Work"}</span>
        </Title>

        <Paragraph centered color={"website-secondary"} weight={"w300"} style={{ paddingBottom: 40 }}>
          {
            "Our Auto-Approval tools are a premium feature that is designed to significantly speed up your approval process and remove redundant tasks."
          }
        </Paragraph>
      </Col>

      <Row justify={"center"} style={{ paddingBottom: 16 }}>
        <div className={"info-steps-wrapper"}>
          <div className={"how-to-start-wrapper"}>
            {applyItems?.map(it => {
              return (
                <div className={"step-wrapper"} key={it?.id}>
                  <HexagonGroup id={it?.id} imageUrl={it?.imageUrl} />
                  <div className={"text-wrapper"}>
                    <Paragraph centered color={"website-secondary"} size={"sm"} weight={"w600"}>
                      {it?.description}
                    </Paragraph>
                    <Paragraph centered color={"orange"} size={"sm"} weight={"w600"}>
                      {it?.descriptionAdditional}
                    </Paragraph>
                  </div>
                </div>
              )
            })}
          </div>
        </div>
      </Row>

      <Col xxl={16} xl={16} lg={18} md={23} sm={23} xs={23}>
        <Paragraph centered color={"website-secondary"} weight={"w300"} size={"sm"} style={{ paddingBottom: 16 }}>
          {
            "If a particular project affects your existing network an agent will have to review and confirm the approval before it is officially sent to the applicant. But all documentation and details are pre-populated for your convenience."
          }
        </Paragraph>
      </Col>

      <Col span={14}>
        <Row align={"middle"} justify={"center"}>
          <Col span={12} xxl={12} xl={12} lg={12} md={12} sm={12} xs={24}>
            <Button btnType={"ghost"} text={"Close"} textColor={"white"} size={"large"} onClick={handleClose} block />
          </Col>
        </Row>
      </Col>
    </Row>
  )
}

export default AutoApprovalInfo
